const toMMddyyyy_slashes = (dateString) => {
  return dateString.length === 8 && !dateString.includes('/') ? [
    dateString.slice(0, 2),
    dateString.slice(2, 4),
    dateString.slice(-4)
  ].join('/') : dateString
}
export default toMMddyyyy_slashes